/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_CopyrightInputs */

const et_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2026 ScalingWebs. Kõik õigused kaitstud. | scalingwebs.com | info@scalingwebs.com | EFFI AI SOLUTIONS OÜ (17306855) |`)
};

const en_footer_copyright = /** @type {(inputs: Footer_CopyrightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`© 2026 ScalingWebs. All rights reserved. | scalingwebs.com | info@scalingwebs.com | EFFI AI SOLUTIONS OÜ (17306855) |`)
};

/**
* | output |
* | --- |
* | "© 2026 ScalingWebs. All rights reserved. \| scalingwebs.com \| info@scalingwebs.com \| EFFI AI SOLUTIONS OÜ (17306855) \|" |
*
* @param {Footer_CopyrightInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_copyright = /** @type {((inputs?: Footer_CopyrightInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_CopyrightInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_footer_copyright(inputs)
	return en_footer_copyright(inputs)
});